import { FlowTransitionStateTypes, FlowTransitionTypes } from './FlowConstants';
export default class FlowDiagramNode {
    constructor (dto, transitionsDto) {
        this.id = null;
        this.type = 'operation';
        this.name = null;
        this.approvers = [];
        this.currentState = FlowTransitionStateTypes.Default;
        this.source = 'dto';
        this.hasMultiValidation = false;
        this.validationsRemaining = 0;

        if (dto && transitionsDto) {
            this.id = dto.StateID;
            this.name = dto.StateName;
            this.currentState = FlowTransitionStateTypes.Default;
            this.hasMultiValidation = dto.HasMultiValidation;

            if (dto.IsCurrentState) {
                this.currentState = FlowTransitionStateTypes.InProcess;

                var currentTransition = transitionsDto.find(x => x.StateFrom === this.id && x.TransitionType === FlowTransitionTypes.Validate);
                if (currentTransition) {
                    this.validationsRemaining = currentTransition.ValidationsRemaining;
                }

                if (this.hasMultiValidation && dto.TransitionHistory && dto.TransitionHistory.length > 0) {
                    this.approvers = dto.TransitionHistory.map(x => ({ name: x.User, date: x.Date }));
                }

            } else if (dto.TransitionHistory && dto.TransitionHistory.length > 0) {
                this.currentState = FlowTransitionStateTypes.Executed;

                dto.TransitionHistory.forEach(approver => {
                    this.approvers.push({ name: approver.User, date: approver.Date });
                });
            }
        }
    }
}
